export function pick<T extends Record<any, any>, K extends keyof T>(
  t: T,
  keys: readonly K[] | K[],
): Pick<T, K> {
  const entries = Object.entries<T>(t).filter(([k]) => keys.includes(k as K));
  return Object.fromEntries(entries) as Pick<T, K>;
}
